/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_All_Members_ConfirmedInputs */

const en_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All members confirmed`)
};

const de_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Mitglieder bestätigt`)
};

const es_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los miembros confirmados`)
};

const fr_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les membres confirmés`)
};

const nl_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle leden bevestigd`)
};

const it_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i membri confermati`)
};

const pt_br2_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os membros confirmados`)
};

const pl_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszyscy członkowie potwierdzeni`)
};

const hu_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minden tag megerősítve`)
};

const ro_admin_dashboard_all_members_confirmed = /** @type {(inputs: Admin_Dashboard_All_Members_ConfirmedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toti membrii confirmati`)
};

/**
* | output |
* | --- |
* | "All members confirmed" |
*
* @param {Admin_Dashboard_All_Members_ConfirmedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_all_members_confirmed = /** @type {((inputs?: Admin_Dashboard_All_Members_ConfirmedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_All_Members_ConfirmedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "de") return de_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "es") return es_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "fr") return fr_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "nl") return nl_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "it") return it_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "pl") return pl_admin_dashboard_all_members_confirmed(inputs)
	if (locale === "hu") return hu_admin_dashboard_all_members_confirmed(inputs)
	return ro_admin_dashboard_all_members_confirmed(inputs)
});
export { admin_dashboard_all_members_confirmed as "admin.dashboard.all_members_confirmed" }